import BaseStaticSelect from './BaseStaticSelect';

export default BaseStaticSelect;
